import { BaseFirebaseService } from 'app/_jaettu-angular/base-firebase.service'

// Palvelin odottaa tositteen kuvia vain osan Firebase Hostingin 60 sekunnin aikarajasta, joten hitaalla
// yhteydellä kuvat ehtivät perille vasta uusintayritykseen. Tallennukset ovat idempotentteja (jo tallentunut
// uusi tosite palauttaa already-exists), joten uusinta samalla pyynnöllä on turvallinen.
const YRITYKSIA = 3

export const kutsuTositteenTallennusta = async <Pyynto, Vastaus extends { e?: string }>(
  firebase: BaseFirebaseService,
  nimi: 'tositeTallennaWeb' | 'tositeSelvityspyyntoTallennaWeb',
  pyynto: Pyynto,
): Promise<Vastaus> => {
  for (let yritys = 1; ; yritys++) {
    const vastaus = await firebase.functionsCall<Pyynto, Vastaus>(nimi, pyynto, undefined, 'europe-north1')
    if (vastaus.e !== 'binary-missing' || yritys === YRITYKSIA) {
      return vastaus
    }
  }
}
